import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Video from '../../components/BrightcoveVideo';
import LinkSection from '../../components/Article/LinkSection';
import ImagePanelsSection from '../../components/Article/ImagePanelsSection';
import Markdown from '../Markdown';
import Placeholder from '../Placeholder';
import {
  Section,
  ChildSection,
  HowToContainer,
  VideoWrapper,
  TextWrapper,
  TextWrapperTwoColumn,
  HowToImageWrapper,
  Text,
  TextTwoColumn,
  Title,
} from './ProductHowTo.style';

const layoutType = {
  imageRight: '2 Column : Image Right',
  imageLeft: '2 Column : Image Left',
  center: '1 Column',
};

const ProductHowTo = ({ howTo }) => (
  <Section>
    {howTo.map(howTo => {
      // productHowTo セクション
      if (howTo.contentType === 'productHowTo') {
        return (
          <HowToContainer key={howTo.entryId}>
            <Title>{howTo.title}</Title>
            {howTo.sections.map(section => {
              if (section.movie) {
                return (
                  <VideoWrapper key={section.entryId}>
                    {section.movie ? <Video {...section.movie} /> : <Placeholder w="100%" pb="56.6%" />}
                  </VideoWrapper>
                );
              }
              if (!section.image) {
                return (
                  <TextWrapper key={section.entryId}>
                    <Markdown src={section.description} Component={Text} />
                  </TextWrapper>
                );
              }
              if (section.layoutType === layoutType.imageRight) {
                return (
                  <TextWrapperTwoColumn key={section.entryId} imageRight>
                    <HowToImageWrapper TwoColumn>
                      <img src={section.image.file.url} alt="" />
                    </HowToImageWrapper>
                    <Markdown src={section.description} Component={TextTwoColumn} />
                  </TextWrapperTwoColumn>
                );
              }
              if (section.layoutType === layoutType.center) {
                return (
                  <TextWrapper key={section.entryId}>
                    <HowToImageWrapper>
                      <img src={section.image.file.url} alt="" />
                    </HowToImageWrapper>
                    <Markdown src={section.description} Component={Text} />
                  </TextWrapper>
                );
              }
              return (
                <TextWrapperTwoColumn key={section.entryId}>
                  <HowToImageWrapper TwoColumn>
                    <img src={section.image.file.url} alt="" />
                  </HowToImageWrapper>
                  <Markdown src={section.description} Component={TextTwoColumn} />
                </TextWrapperTwoColumn>
              );
            })}
          </HowToContainer>
        );
      }
      // Button セクション
      if (howTo.contentType === 'link') {
        return (
          <ChildSection>
            <LinkSection key={howTo.entryId} {...howTo} />
          </ChildSection>
        );
      }
      // Image Panel セクション
      if (howTo.contentType === 'campaignPageImagePanelsSection') {
        return (
          <ChildSection>
            <ImagePanelsSection key={howTo.entryId} {...howTo} />
          </ChildSection>
        );
      }
    })}
  </Section>
);

ProductHowTo.defaultProps = {
  howTo: [],
};

ProductHowTo.propTypes = {
  howTo: PropTypes.arrayOf(PropTypes.shape({})),
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyProductPage,
});

export default connect(mapState)(ProductHowTo);



// WEBPACK FOOTER //
// ./src/components/ProductHowTo/ProductHowTo.js